export const HOME = '/home';
export const RESULTS = '/results';
export const MY_ORDERS = '/my-orders';
export const REPORTS = '/reports/:reqId';
export const ACCOUNT = '/account';
export const GENETIC_COUNSELING = '/:reqId/genetic_counseling';
export const ERROR = '/error';
export const ORDER = '/order';
export const ACCESS = '/access';
export const ACCESS_SUCCESS = '/access/success';
export const LOGIN = '/login';
export const SHARE_RESULTS = '/share-results';

// These routes do not have a leading '/' because they are used as relative
// nested routes under `<Route path={ROUTES.PARTNERSHIP}>` and `<Route path=":partner">`
export const PARTNERSHIP = 'partnership';
export const BRIDGEBIO_REFERRAL = '/partnership/bridgebio/refer';
export const FVT_WELCOME = '/fvt/welcome';
export const FVT_LOGIN = '/fvt/login';
export const FVT_INVITE = '/fvt/invite';
export const FVT_FAMILY = '/fvt/family';
export const ORDER_NEW_TEST = 'new-test';
export const ORDER_GET_STARTED = 'get-started';
export const ORDER_LAUNCH = 'launch';
export const ORDER_CHECK = 'check-eligibility';
export const ORDER_WIZARD = 'wizard';
export const ORDER_WHATS_NEXT = 'whats-next';
export const ORDER_NOT_ELIGIBLE = 'not-eligible';

// Kept for backward compatibility with existing imports
export const HOMEPAGE = HOME;
export const ORDERS = MY_ORDERS;

export const ROUTES = {
  HOME,
  RESULTS,
  MY_ORDERS,
  ACCOUNT,
  GENETIC_COUNSELING,
  ERROR,
  ORDER,
  ORDER_NEW_TEST,
  REPORTS,
  ACCESS,
  ACCESS_SUCCESS,
  LOGIN,
  SHARE_RESULTS,
  PARTNERSHIP,
  BRIDGEBIO_REFERRAL,
  FVT_WELCOME,
  FVT_LOGIN,
  FVT_INVITE,
  FVT_FAMILY,
  ORDER_GET_STARTED,
  ORDER_LAUNCH,
  ORDER_CHECK,
  ORDER_WIZARD,
  ORDER_WHATS_NEXT,
  ORDER_NOT_ELIGIBLE,
};

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export const SUPPRESSED_AUTH_ERROR_ROUTES: string[] = [ACCESS, ACCESS_SUCCESS];
